export default "__VITE_ASSET__bea9fcec__"